import {Component} from "@angular/core";
import {TranslocoService} from "@ngneat/transloco";
import {LoaderService} from "./services/loader.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ta_backoffice_fe';

  constructor(
    public loaderSvc: LoaderService
  ) {
  }
}
